export interface PromoPortada {
    idPromo: number;
    tipoVehiculo: string;
    urlBanner: string;
    urlLista: string;
    urlImagen: string;
    urlIcono: string;
}

export class PromoPortadaHelper {
    static fromApi(data: any): PromoPortada {
        return {
            idPromo: data['IDPROMO'] ?? null,
            tipoVehiculo: data['TIPOVEHICULO'] ?? null,
            urlBanner: data['URL_BANNER'] ?? null,
            urlLista: data['URL_LISTA'] ?? null,
            urlImagen: data['URL_IMAGEN'] ?? null,
            urlIcono: data['URL_ICONO'] ?? null,
        };
    }
}
